import React, {useCallback} from "react";
import {useDispatch} from "react-redux";
import {Paper} from "@material-ui/core";

import locales from "../locales";
import Title from "../components/Common/Title";
import {useRestaurant} from "../selectors/RestaurantSelectors";
import {defaultGuestmeGateway} from "../config/constants";
import {GuestmeNotificationsSettingsWidget} from "../widgets";
import {updateRestaurantInfo} from "../actions/restaurantsInfo/RestaurantsInfoActions";

const GuestmeNotificationsPage = () => {
  const dispatch = useDispatch();
  const currentRestaurant = useRestaurant();

  const disableGuestmeGateway = useCallback(() => {
    const {gateways} = currentRestaurant.settings.smsNotificationSettings;
    const notGuestme = gateways.filter(g => g.type !== defaultGuestmeGateway.type) || [];

    dispatch(updateRestaurantInfo({
      type: "smsNotificationSettings",
      currentRestaurant,
      isEnabled: false,
      gateways: [...notGuestme, {
        ...defaultGuestmeGateway,
        isEnabled: false,
      }],
    }));
  }, [currentRestaurant?.settings?.smsNotificationSettings?.gateways]);

  return (
    <>
      <Paper elevation={3}>
        <Title text={locales.t("gateways.title")} borderBottom/>
      </Paper>
      <GuestmeNotificationsSettingsWidget onDisable={disableGuestmeGateway} />
    </>
  );
}

export default GuestmeNotificationsPage;
